<template>
  <span>
    <el-dialog title="常用规格" :visible.sync="visible" width="700px">
      <div>规格名：{{ opts.spcificationName }}</div>
      <el-table :data="tableData" height="350" border style="width: 100%">
        <el-table-column prop="specificationValue" label="规格值" align="center"> </el-table-column>
        <el-table-column prop="operate" label="操作" width="240" align="center">
          <template slot-scope="{ row }">
            <el-link type="primary" class="mr-10" @click="addOredit(row)">编辑</el-link>
            <el-link type="primary" class="mr-10" @click="useItem(row)">应用至资料</el-link>
            <el-link type="danger" @click="deleteItem(row)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="addOredit({})">新增模板</el-button>
      </span>
    </el-dialog>
    <EditUsualTemplateDialog ref="EditUsualTemplateDialogRef"></EditUsualTemplateDialog>
  </span>
</template>

<script>
// 常用规格编辑弹窗
import EditUsualTemplateDialog from './EditUsualTemplateDialog.vue';
import { getUsualSpecification, deleteUsualSpecification } from '@/servers/prod/center/index.js';
export default {
  components: {
    EditUsualTemplateDialog,
  },
  data() {
    return {
      visible: false,
      opts: {
        spcificationName: '',
      },
      tableData: [],
    };
  },
  watch: {
    visible(v) {
      if (!v) {
        this.opts.spcificationName = '';
      }
    },
  },
  methods: {
    method_open(opts) {
      this.visible = true;
      this.opts = opts || {};
      this.getList();
    },
    async getList() {
      let list = await getUsualSpecification(this.opts.spcificationName);
      this.tableData = list;
    },
    addOredit(row = {}) {
      row.specificationName = this.opts.spcificationName;
      this.$refs.EditUsualTemplateDialogRef.method_open(row, () => {
        this.getList();
      });
    },
    useItem(row) {
      this.visible = false;
      this.opts.usualFn && this.opts.usualFn(row);
    },
    deleteItem(row) {
      this.$confirm('是否删除该规格模版?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        width: '500px',
      }).then(async () => {
        let res = await deleteUsualSpecification({ id: row.id });
        if (res) {
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
        }
        this.getList();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.sort-title {
  font-size: 14px;
  flex: 1;
  & + & {
    margin-top: 12px;
  }
}
.sort-row {
  margin: 10px 0;
  display: flex;
  flex-direction: column;
}
.addBtn {
  padding-left: 0;
  ::v-deep i {
    line-height: 16px;
    margin-top: -2px;
  }
}
</style>